import { getParameterFromURL } from './getParameterFromUrl';

/**
 * Themed first screen shown by the onboarding funnel (picked from the utm_content
 * tag of the creative). Only funnels with a themed first screen send it, so the
 * absence of the param is the normal case — never substitute a default.
 *
 * NB: `potty_training` here is a value of `first_screen`, not the quiz answer
 * param of the same name.
 */
export type FirstScreen =
  | 'general'
  | 'stop_biting'
  | 'crate_training'
  | 'potty_training';

const FIRST_SCREENS: readonly FirstScreen[] = [
  'general',
  'stop_biting',
  'crate_training',
  'potty_training',
];

const isFirstScreen = (value: string | null): value is FirstScreen => {
  return FIRST_SCREENS.includes(value as FirstScreen);
};

export const getFirstScreenFromURL = (url?: string): FirstScreen | null => {
  const firstScreen = getParameterFromURL('first_screen', url);

  return isFirstScreen(firstScreen) ? firstScreen : null;
};
